import calendarService from "../../apiServices/common/calendarService";
import { setCalenderEvents, setGoogleCalenderEvents } from "../../store/slices/common/calendarSlice";


export function getCalenderEventsDetails(startDateTime: string, endDateTime: string, userEmail: string) {
    return async function (dispatch: any, getState: any) {
        let response = await calendarService.getCalendarEvents(startDateTime, endDateTime, userEmail);
        if (response?.success === true) {
            dispatch(setCalenderEvents(response.data));
        } else {
            console.log("error");
        }
    };
}

export function getGoogleCalenderEventsDetails(startDateTime: string, endDateTime: string, userEmail: string) {
    return async function (dispatch: any, getState: any) {
        let response = await calendarService.getGoogleCalendarEvents(startDateTime, endDateTime, userEmail);
        if (response?.success === true) {
            dispatch(setGoogleCalenderEvents(response.data));
        } else {
            console.log("error");
        }
    };
}